import React, { Component } from "react";
import {
  Error,
  formatDateFromData,
  selectFormat,
  MAIN_COLORS,
  CustomizedXAxisTickTime,
  StandardTooltip,
} from "components/Utils/Utils.js";

import Heading from "components/Elements/Heading";
import {
  fetchInsights,
  InsightsLineLabel,
  InsightsTickIndicator,
  OpenSelectedInsight,
  RenderTooltipInsights,
  CloseSelectedInsight,
} from "components/Utils/InsightsUtils";

import {
  CartesianGrid,
  LineChart,
  ResponsiveContainer,
  Line,
  XAxis,
  YAxis,
  ReferenceLine,
  Tooltip,
  LabelList,
  ReferenceDot,
} from "recharts";

import clsx from "clsx";
import { getXrayTooltipPosition } from "helpers/DOM";
import { XRayTooltip } from "components/Utils/XRayTooltip/XRayTooltip";

class HearstCompletionRateTrending extends Component {
  constructor() {
    super();
    this.state = {
      widgetsInsights: [],
      width: 0,
      height: 0,
      tooltip: {
        show: false,
        x: 0,
        y: 0,
      },
    };

    this.node = React.createRef();
    this.divPosition = React.createRef();
  }

  closeTooltip = () => {
    this.setState({
      tooltip: { show: false },
    });
  };

  CustomizedDot = (props) => {
    const { cx, cy } = props;

    return (
      <svg
        x={cx - 3}
        y={cy - 3}
        width={7}
        height={7}
        fill={MAIN_COLORS[0]}
        viewBox="0 0 1024 1024"
      >
        <path d="M517.0 53.248q95.232 0 179.2 36.352t145.92 98.304 98.304 145.92 36.352 179.2-36.352 179.2-98.304 145.92-145.92 98.304-179.2 36.352-179.2-36.352-145.92-98.304-98.304-145.92-36.352-179.2 36.352-179.2 98.304-145.92 145.92-98.304 179.2-36.352zM663.552 261.12q-15.36 0-28.16 6.656t-23.04 18.432-15.872 " />
      </svg>
    );
  };

  updatePosition = () => {
    if (!this.chartRef) return;
    const { containerWidth, containerHeight } = this.chartRef.state;
    this.setState({ width: containerWidth, height: containerHeight });
  };

  componentDidMount() {
    this.props.childRef(this);

    window.addEventListener("resize", this.updatePosition);
    window.addEventListener("click", this.handleClickOutside);

    setTimeout(() => {
      this.updatePosition();
    }, 500);

    const { data, project_id, project, insights, insightsConfig } = this.props;
    if (insights) {
      const insightsPromise = fetchInsights(
        data,
        project,
        project_id,
        insightsConfig
      );
      if (insightsPromise !== undefined) {
        insightsPromise
          .then((data) => {
            if (data && data.length > 0) {
              this.setState({
                widgetsInsights: data,
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  }

  componentWillMount() {
    this.updatePosition();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updatePosition);
    window.removeEventListener("click", this.handleClickOutside);
  }

  handleClickOutside = (e) => {
    if (
      this.divPosition.current &&
      this.divPosition.current.contains(e.target)
    ) {
      return;
    } else {
      this.closeTooltip();
    }
  };

  generateDataForExport = () => {
    const data = this.props.data.data.chart;
    let formattedData = [];

    Object.keys(data).map((i) =>
      formattedData.push({
        Date: selectFormat("date", data[i].date),
        "Video Completion Rate": selectFormat(
          "percentage",
          data[i].video_completion_rate / 100
        ),
      })
    );

    return formattedData;
  };

  getExportData = () => ({
    data: this.generateDataForExport(),
    opts: {
      type: "other",
    },
  });

  // getExportData = () => {
  //   return {
  //     data: this.props.data.data.chart,
  //     series: {
  //       format: "percentage",
  //     },
  //     opts: {
  //       type: "chart",
  //       date: {
  //         // overwrites the default settings for date only when the date is in ISO format
  //         defined: isDateFromDataInISOFormat(this.props.data.data.chart),
  //         format: "YYYY-MM-DD",
  //         viewFormat: "YYYY-MM-DD",
  //       },
  //     },
  //   };
  // };

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    // get the min/max from the array
    const [min, max] = data.data.chart.reduce(
      (array, current) => {
        // get and set the min value
        array[0] =
          current.video_completion_rate < array[0]
            ? current.video_completion_rate
            : array[0];
        // get and set the max value
        array[1] =
          current.video_completion_rate > array[1]
            ? current.video_completion_rate
            : array[1];

        return array;
      },
      // default min, default max
      [data.data.chart[0].video_completion_rate, 0]
    );

    let preparedData = formatDateFromData(this.props.data.data.chart);

    const off =
      preparedData.reduce(
        (total, current) => (total += current.video_completion_rate),
        0
      ) / preparedData.length;

    const insightsData = this.state.widgetsInsights.length > 0;
    return (
      <div>
        <div className="row mb-4">
          <div className="col">
            <Heading size={5}>
              {" "}
              Min/Max: {selectFormat("number", min, "0.0000")} to{" "}
              {selectFormat("number", max, "0.0000")}
            </Heading>{" "}
          </div>{" "}
        </div>
        <div>
          <div className="d-flex mt-2" ref={this.divPosition}>
            <ResponsiveContainer height={200}>
              <LineChart
                isAnimationActive={false}
                data={preparedData}
                margin={{ top: 12, right: 0, bottom: 20, left: 0 }}
                onMouseOver={(e) => CloseSelectedInsight(this.node)}
                onMouseOut={(e) =>
                  OpenSelectedInsight(
                    // this.state.insightsData,
                    this.node,
                    !this.state.tooltip.show
                  )
                }
                onClick={(d) => {
                  if (d !== null) {
                    const extra = {
                      video_completion_rate: {
                        label: "Rate",
                        color: MAIN_COLORS[0],
                        value:
                          selectFormat(
                            "number",
                            d.activePayload[0].value,
                            "0.0000"
                          ) + "%",
                      },
                    };
                    const indicator = "lineChart";

                    d.extra = extra;
                    d.indicator = indicator;
                    this.setState({
                      tooltip: { ...d, show: true },
                    });
                  } else {
                    this.closeTooltip();
                  }
                }}
              >
                <CartesianGrid
                  stroke="#FEE5DE"
                  strokeDasharray="3 3"
                  vertical={false}
                />
                <defs>
                  <linearGradient
                    id="splitColor"
                    x1="0"
                    y1="0"
                    x2="0"
                    y2={"1.5"}
                  >
                    <stop
                      offset={off}
                      stopColor={MAIN_COLORS[0]}
                      stopOpacity={1}
                    />
                    <stop
                      offset={off}
                      stopColor={MAIN_COLORS[1]}
                      stopOpacity={1}
                    />
                  </linearGradient>
                </defs>
                <Line
                  type="monotone"
                  dataKey="video_completion_rate"
                  stroke="url(#splitColor)"
                  strokeWidth={2}
                  dot={<this.CustomizedDot />}
                  isAnimationActive={false}
                />

                {this.state.widgetsInsights.length > 0 && (
                  <LabelList
                    dataKey="date"
                    content={
                      <InsightsLineLabel
                        height={250}
                        data={this.props.data}
                        insights={this.state.widgetsInsights}
                        showIndicator={!this.state.tooltip.show}
                        node={this.node}
                      />
                    }
                  />
                )}

                <XAxis
                  dataKey="date"
                  axisLine={false}
                  tickLine={false}
                  scale="point"
                  interval="preserveStartEnd"
                  tick={<CustomizedXAxisTickTime />}
                />

                <YAxis
                  dataKey="video_completion_rate"
                  axisLine={false}
                  tickLine={false}
                  mirror={true}
                />
                <ReferenceLine
                  y={off}
                  label={{
                    position: "insideBottomLeft",
                    value: `Threshold: ${selectFormat("percentage", off)}`,
                    fill: "#868e96",
                  }}
                  stroke="#868e96"
                  position="start"
                />

                {!this.state.tooltip.show && (
                  <Tooltip
                    cursor={{ fill: "#eee", opacity: 0.5 }}
                    content={
                      <StandardTooltip
                        render={({ data }) => {
                          const payload = data(this.props);

                          if (payload !== null) {
                            const tooltip_data = payload[0].payload;
                            return (
                              <div className="standard-tooltip">
                                <header className="standard-tooltip__header">
                                  <span className="standard-tooltip__key-header">
                                    Date
                                  </span>
                                  <span className="standard-tooltip__value-header">
                                    {tooltip_data.date}
                                  </span>
                                </header>

                                <main className="standard-tooltip__main">
                                  <div className="standard-tooltip__item">
                                    <span
                                      className="standard-tooltip__icon"
                                      style={{
                                        background: MAIN_COLORS[0],
                                      }}
                                    />
                                    <span
                                      className={clsx(
                                        "standard-tooltip__key",
                                        "text-capitalize"
                                      )}
                                      style={{ color: MAIN_COLORS[0] }}
                                    >
                                      Rate
                                    </span>
                                    <span className="standard-tooltip__value">
                                      {selectFormat(
                                        "number",
                                        tooltip_data.video_completion_rate,
                                        "0.0000"
                                      )}
                                      %
                                    </span>
                                  </div>
                                </main>
                              </div>
                            );
                          }
                        }}
                      />
                    }
                  />
                )}

                {insightsData &&
                  this.state.widgetsInsights.map((o, index) => {
                    return (
                      <ReferenceDot
                        x={o.date}
                        y={0}
                        key={this.props.title + index}
                        ifOverflow="extendDomain"
                        //   yAxisId="right"
                        shape={
                          <InsightsTickIndicator
                            insights={this.state.widgetsInsights}
                            date={o.date}
                            node={this.node}
                          />
                        }
                      />
                    );
                  })}
              </LineChart>
            </ResponsiveContainer>
            <div className="featured-insight-tooltip" ref={this.node}>
              {this.state.widgetsInsights.length > 0 &&
                !this.state.tooltip.show && (
                  <RenderTooltipInsights data={this.state.widgetsInsights} />
                )}
            </div>
          </div>
          {this.state.tooltip.activeCoordinate ? (
            <div
              className="xray-tooltip-container"
              style={{
                top: this.state.tooltip.activeCoordinate.y + 100 + "px",
                left:
                  this.state.tooltip.activeCoordinate.x + 1062 + 220 <
                  this.state.width
                    ? this.state.tooltip.activeCoordinate.x + "px"
                    : this.state.tooltip.activeCoordinate.x -
                      getXrayTooltipPosition(
                        this.divPosition.current,
                        this.state.tooltip.activeCoordinate
                      ) +
                      "px",
                opacity: this.state.tooltip.show ? 1.0 : 0.0,
                visibility: this.state.tooltip.show ? "visible" : "hidden",
              }}
            >
              <XRayTooltip
                data={this.state.tooltip}
                close={this.closeTooltip.bind(this)}
              />
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default HearstCompletionRateTrending;
